'use client';

import { ReactNode } from 'react';

interface FilterBarProps {
  children: ReactNode;
  className?: string;
  actions?: ReactNode;
}

/**
 * FilterBar Component
 * Consistent wrapper for filter controls across pages
 * Provides standard padding, background, and layout
 * Supports optional actions slot on the right side
 */
export const FilterBar: React.FC<FilterBarProps> = ({ children, className = '', actions }) => {
  return (
    <div className={`px-responsive py-3 ${className}`}>
      <div className="flex items-center gap-2">
        <div className="grid grid-cols-[auto_1fr_1fr_1fr] items-center gap-2 flex-1">
          {children}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
